// extracted by mini-css-extract-plugin
module.exports = {"futureText":"FutureText_futureText__cJCEQ","fade-in-out":"FutureText_fade-in-out___ELB_","fade-out":"FutureText_fade-out__zUVDo"};